export const profileTh = {
    prestige_club: 'สมาชิกเอไอเอ เพรสทีจ คลับ',
    ambassador: '(แอมบาสเดอร์)',
    tier_lvl: {
        'c': 'ระดับ คลาสสิก',
        's': 'ระดับ ซิลเวอร์',
        'g': 'ระดับ โกลด์',
        'p': 'ระดับ แพลทินัม'
    },
    privilege_id: 'พริวิเลจ ไอดี : ',
    prestige_privilege: 'ยอดใช้เอกสิทธิ์จากโครงการเอไอเอ เพรสทีจ คลับ',

    column_privilege: 'เอกสิทธิ์',
    column_quota: 'จำนวนสิทธิ',
    column_left: 'คงเหลือ',
    column_blank: '',

    remark_headline: 'หมายเหตุ',
    remark: 'การเปลี่ยนแปลงของยอดเบี้ยประกันภัยรวม ส่งผลต่อสถานะสมาชิกของท่าน ซึ่งเอกสิทธิ์ที่ท่านได้รับจะปรับเปลี่ยนตามสถานะของท่าน ตามเงื่อนไขในแต่ละเอกสิทธิ์'
}
